export default "__VITE_ASSET__C7k9jcuT__"